import React, { Fragment, ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";

// MUI
import { GridSize } from "@mui/material";

// Custom Components
import Typography from "@mui/material/Typography";
import { GridItem } from "@/ui/Grid";

import FormGenerator from "@/lib/FormGenerator";

// Types
import { FormContentProps } from "@/@types/components/formContent";
import { ControlField, FieldAny, IFieldsWControlCollection } from "@/@types/models/model";
import { FormFieldControls } from "@/@types/lib/formGenerator";
import DialogContext from "@/ui/DialogContext/DialogContext";

// const customBottomStyle = {
//   alignSelf: "flex-end"
// };

// const customFormHeightStyle = {
//   height: "80px"
// };

function FormContent(props: FormContentProps) {
  const { t } = useTranslation();
  const { onFieldChange, onSubmit, columns } = props;
  const { title, mode, record, fieldNames, validation, subModels, fields } = props;

  const fg = new FormGenerator();

  type HashMap = { [id: string | number]: any }

  const dialogContext = useContext(DialogContext);

 const handleFieldChange = (value: unknown, source: string) => {
    let isValueParsedAndSubmit = false;
    try {
      const tmp: HashMap = JSON.parse(value as string);
      isValueParsedAndSubmit = '#submit' in tmp && tmp['#submit'];
    } catch (_) {
      // do nothing and proceed
    }

    if (isValueParsedAndSubmit /* value && typeof value == "object" && value.hasOwnProperty("keyCode") && (value as { keyCode: number })["keyCode"] === 13 */) {
      if (onSubmit) {
        onSubmit();
      }
    } else if (onFieldChange) {
      onFieldChange(value, source);
    }
  };

  const getWidth = (f: FieldAny): GridSize => {
    if (f && f.width && f.width === "full") {
      return 12;
    } 

    switch (columns) {
      case 1:
        return 12;
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
        return 3;
      default:
        return 6;
    }
    
  };

  const renderFields: IFieldsWControlCollection = fieldNames ? fieldNames.map((name) => fields.find((f) => f.source === name)).filter(x => x !== undefined).map(x => x as ControlField) : [];

  let controls: FormFieldControls = {};
  switch (mode) {
    case "insert":
    case "update": {
      controls = fg.generateFormControls(
        renderFields,
        "form",
        "edit",
        record,
        validation,
        handleFieldChange,
        subModels,
      );
      break;
    }
    case "view": {
      controls = fg.generateFormControls(renderFields, "form", "view", record, undefined, undefined, subModels, dialogContext.showDialog);
      break;
    }
    case 'simpleView':{
      controls = fg.generateFormControls(renderFields, "form", "simpleView", record, undefined, undefined, subModels);
      break;
    }
    default:
      break;
  }

  renderFields.map((field) => {
    field.control = controls.hasOwnProperty(field.source) ? controls[field.source] as ReactElement : <Fragment>-</Fragment>;
  });

  return (
    <>
      {title ? (
        <GridItem size={12}>
          <Typography variant="h6" component="h2" paragraph>
            {t(title)}
          </Typography>
        </GridItem>
      ) : null}
      {renderFields.map((f) => (
        <GridItem
          size={{xs: 12, sm: getWidth(f)}}
          key={f.source}
          // style={f.bottom ? customBottomStyle : f.originalHeight ? customFormHeightStyle : null}
        >
          {f.control}
        </GridItem>
      ))}
    </>
  );
}

export default FormContent;
